<template>
    <div>
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form
                    :form="queryForm"
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                    @handlePickerDateChange="handlePickerDateChange"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>

        <Table 
            ref="orderTableRef"
            :table="table"
            @expandRow="expandRow"
            @changePage="changePage"
            @changePageSize="changePageSize"
            @selectRow="selectRow"
            @selectAllRow="selectAllRow"
            @sorterChange="sorterChange"
            @cellClick="cellClick"
        >
            <!-- 表头操作 -->
            <!-- <template v-slot:operate>
                <a-button type="primary" size="mini" v-permission="'setting.order.createOrder'" @click="handle('createOrder')">
                    <icon-plus-circle size="13" style="marginRight:5px;"/>
                    {{ $t('order.create') }}
                </a-button>
            </template> -->

            <!-- 父表格操作 -->
            <template v-slot:tableOperate="{ props }">
                <a-button 
                    v-permission="'setting.B2BShopOrder.confirm'"
                    type="primary" size="mini" 
                    style="margin: 1px;width: 90px;"
                    :disabled="props.record.check_status_val != 0 && props.record.check_status_val != 3"
                    @click="handle('edit',props.record)"
                >{{ $t('B2BShopOrder.confirm') }}</a-button>
                <a-button 
                    v-permission="'setting.B2BShopOrder.confirm'"
                    type="primary" status="danger"  size="mini" 
                    style="margin: 1px;width: 90px;"
                    :disabled="props.record.check_status_val != 0"
                    @click="handle('cancel',props.record)"
                >{{ $t('base.cancel') }}</a-button>
            </template>

            <!-- 父表格自定义字段 -->
            <template v-slot:columns="{ props }">
                <!-- <div v-if="props.column.key == 'order_name'" :class="{'orderName': props.record.order_name != '-' && props.record.check_status_val == 1}" @click="goOrderList(props.record.order_name, props.record.check_status_val)">{{ props.record.order_name }}</div> -->
                <div 
                    v-if="props.column.key == 'order_name'" 
                    :class="{'confirmedName': props.record.split_list.length != 0 && props.record.check_status_val == 1}" 
                >
                    <div v-if="props.record.split_list.length == 0">-</div>
                    <div v-else>
                        <div 
                            v-for="(item,index) in props.record.split_list" 
                            :key="index" 
                            @click="goOrderList(item.order_name, props.record.check_status_val)"
                        >{{ item.order_name }}</div> 
                    </div>
                </div>
                <div v-if="props.column.key == 'dealer_order_status'">
                    <a-tag color="magenta">{{ props.record.dealer_order_status }}</a-tag>
                </div>
                <div v-if="props.column.key == 'check_status'">
                    <a-tag v-if="props.record.check_status_val != undefined" :color="props.record.check_status_val == 0? 'red' : props.record.check_status_val == 1?  'green' : props.record.check_status_val == 3? 'blue' : 'gray' ">{{ props.record.check_status }}</a-tag>
                    <span v-else>-</span>
                </div>
                <div v-if="props.column.key == 'courier_status'">
                    <a-tag v-if="props.record.courier_status_val != undefined" :color="courierStatusColor[props.record.courier_status_val]">{{ props.record.courier_status }}</a-tag>
                    <span v-else>-</span>
                </div>
                <div v-if="props.column.key == 'customer_level'">
                    <a-tag v-if="props.record.customer_level_val !== undefined" :color="props.record.customer_level_val == 1? 'green' : props.record.customer_level_val == 3? 'gray' : props.record.customer_level_val == 5? 'gold' : 'blue'">{{ props.record.customer_level }}</a-tag>
                    <span v-else>-</span>
                </div>
                <div v-if="props.column.key == 'user_note'">
                    <a-tooltip :content="props.record.user_note">
                        <div class="user_note">{{ props.record.user_note }}</div>
                    </a-tooltip>
                </div>
            </template>

            <!-- 子表格自定义子字段 -->
            <template v-slot:childColumns="{ props }">
                <div v-if="props.column.key == 'delivery_type'">
                    <a-tag checkable :color="props.record.delivery_type_val == '1'? 'blue' : props.record.delivery_type_val == '2'? 'green' : 'gold'">{{ props.record.delivery_type }}</a-tag>
                </div>
                <div v-if="props.column.key == 'ordered_flag'">
                    <span style="color:red" v-if="props.record.ordered_flag_val == 0">{{ props.record.ordered_flag }}</span>
                    <span style="color:green" v-else-if="props.record.ordered_flag_val == 1">{{ props.record.ordered_flag }}</span>
                    <span style="color:black" v-else>{{ props.record.ordered_flag }}</span>
                </div>
            </template>
        </Table>

        <!-- 新增模态框 -->
        <a-modal 
            v-model:visible="confirmModalVisible"
            :title="$t('dealerPreOrder.orderOperatetype')"
            @ok="handleConfirmModalOk"
            @cancel="handleConfirmModalCancel"
        >
            <a-radio-group v-model="order_category">
                <a-radio value="bike" :disabled="line_bike_arr.length == 0">{{ $t('dealerPreOrder.operateWhole') }}</a-radio>
                <a-radio value="part" :disabled="line_part_arr.length == 0">{{ $t('dealerPreOrder.operatePart') }}</a-radio>
            </a-radio-group>
        </a-modal>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { DealerApi } from '@/api/DealerApi.js';
    import { OrderApi } from '@/api/OrderApi.js'; 
    import { FinancialApi } from '@/api/FinancialApi.js'; 
    import { Message, Modal } from '@arco-design/web-vue';
    import { useRouter } from 'vue-router';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { 
        B2BShopOrderListQuery,
    } from './queryConfig/B2BShopOrderListQuery.js';
    
    import { dateToTimestamp, timestampToDate, formatterToPoint, formatterToComma, getNowDate, getWeek } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { multiply, add, subtract, divide } from 'accurate-core';

    const router = useRouter()
    const localeStore = useLocale()
    const { t } = useI18n()

    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    const locale = ref(localStorage.getItem('locale'))

    const orderSource = ref({})
    const orderTableRef  = ref(null)
    const showForm = ref(false)
    const queryForm = reactive(B2BShopOrderListQuery)
    const confirmModalVisible = ref(false)
    const rowData = ref(null)
    const order_category = ref('')
    const line_bike_arr = ref([])
    const line_part_arr = ref([])

    // 父表格
    const table = ref({
        datas:[],
        columns:[
            // {
            //     // title: 'B2B Shop订单名称',
            //     title:t('order.dealerOrderName'),
            //     dataIndex: 'dealer_order_name',
            //     key:'dealer_order_name',
            //     width:'180',
            //     align:'left',
            // },
            {
                // title: '订单名称',
                title:t('order.dealerOrderName'),
                dataIndex: 'dealer_order_name',
                key:'dealer_order_name',
                width:'180',
                align:'left',
                // slotName:'slot',
            },
                {
                // title: '确认订单名称',
                title:t('order.orderName'),
                dataIndex: 'order_name',
                key:'order_name',
                width:'180',
                align:'left',
                slotName:'slot',
            },
            {
                // title: '订单来源',
                title:t('order.orderSource'),
                dataIndex: 'source',
                key:'source',
                width:'150',
                align:'left',
            },
            {
                // title: '订单状态',
                title:t('order.orderStatus'),
                dataIndex: 'dealer_order_status',
                key:'dealer_order_status',
                width:'150',
                align:'left',
                slotName: 'slot'
            }, 
            {
                // title: '验证状态',
                title:t('B2BShopOrder.verifyStatus'),
                dataIndex: 'check_status',
                key:'check_status',
                width:'140',
                align:'left',
                slotName: 'slot'
            },
            {
                // title: '发货状态',
                title:t('order.deliverStatus'),
                dataIndex: 'courier_status',
                key:'courier_status',
                width:'150',
                align:'left',
                slotName: 'slot'
            },
            {
                // title: '数量',
                title:t('order.quantity'),
                dataIndex: 'quantity',
                key:'quantity',
                width:'110',
                align:'left',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '金额',
                title:t('order.payAmount'),
                dataIndex: 'pay_amount',
                key:'pay_amount',
                width:'140',
                align:'left',
            },
            {
                // title: '订单时间',
                title:t('order.orderTimestamp'),
                dataIndex: 'order_timestamp',
                key:'order_timestamp',
                width:'140',
                align:'left',
                ellipsis:true,
                tooltip:true,
                sortable: {
                    sortDirections: ['ascend', 'descend'],
                },
            },
            {
                // title: '国家',
                title:t('order.country'),
                dataIndex: 'country',
                key:'country',
                width:'140',
                align:'left',
            },
            {
                // title: '备注',
                title:t('order.userNote'),
                dataIndex: 'user_note',
                key:'user_note',
                width:'180',
                align:'left',
                slotName: 'slot'
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width: '120',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                // x:1000,
                y: 580
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            pagination:{
                size:'mini',
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })
    // 子表格
    const innerColumns = ref([ 
        {
            // title: 'No.',
            title:'#',
            dataIndex: 'serial',
            key: 'product_name',
            width: '80',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: 'sku',
            title:t('order.sku'),
            dataIndex: 'sku',
            key: 'sku',
            width: '220',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '物料编码',
            title:t('order.inventoryCode'),
            dataIndex: 'inventory_code',
            key: 'inventory_code',
            width: '180',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '车架号',
            title:t('order.frameNumber'),
            dataIndex: 'user_frame_number',
            key: 'user_frame_number',
            width: '180',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '上市年份',
            title:t('dealerPreOrder.modelYear'),
            dataIndex: 'model_year',
            key: 'model_year',
            width: '100',
            align: 'left',
        },
        {
            // title: '车型',
            title:t('dealerPreOrder.modelVersion'),
            dataIndex: 'model_version',
            key: 'model_version',
            width: '260',
            align: 'left',
        },
        {
            // title: '确认状态',
            title:t('dealerPreOrder.confirmStatus'),
            dataIndex: 'ordered_flag',
            key: 'ordered_flag',
            width: '130',
            align: 'left',
            slotName:'slot'
        },
        {
            // title: '颜色',
            title:t('dealerPreOrder.frameColor'),
            dataIndex: 'frame_color',
            key: 'frame_color',
            width: '120',
            align: 'left',
        },
        {
            // title: '车架',
            title:t('dealerPreOrder.frameShape'),
            dataIndex: 'frame_shape',
            key: 'frame_shape',
            width: '150',
            align: 'left',
        },
        {
            // title: '尺寸',
            title:t('dealerPreOrder.frameSize'),
            dataIndex: 'frame_size',
            key: 'frame_size',
            width: '100',
            align: 'left',
        },
        {
            // title: '单价',
            title:t('dealerPreOrder.price'),
            dataIndex: 'amount',
            key: 'amount',
            width: '100',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '数量',
            title:t('order.quantity'),
            dataIndex: 'quantity',
            key: 'quantity',
            width: '100',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '总价',
            title:t('order.payAmount'),
            dataIndex: 'pay_amount',
            key: 'pay_amount',
            width: '120',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '订单税额',
            title:t('order.orderTax'),
            dataIndex: 'order_tax',
            key: 'order_tax',
            width: '120',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '税率',
            title:t('order.taxRate'),
            dataIndex: 'tax_rate',
            key: 'tax_rate',
            width: '120',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        {
            // title: '备注',
            title:t('order.instruction'),
            dataIndex: 'user_comment',
            key: 'user_comment',
            width: '160',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        // user_frame_number
        {
            title:t('order.frameNumber'),
            dataIndex: 'user_frame_number',
            key: 'user_frame_number',
            width: '180',
            align: 'left',
            ellipsis:true,
            tooltip:true,
        },
        // {
        //     // title: '发货方式',
        //     title:t('order.deliveryType'),
        //     dataIndex: 'delivery_type',
        //     key: 'delivery_type',
        //     width: '120',
        //     align: 'left',
        //     ellipsis:true,
        //     tooltip:true,
        //     slotName:'slot',
        // },  
        // {
        //     // title: '预计发货时间',
        //     title:t('order.handleTimestamp'),
        //     dataIndex: 'handle_timestamp_val',
        //     key: 'handle_timestamp_val',
        //     width: '130',
        //     align: 'left',
        //     ellipsis:true,
        //     tooltip:true,
        // }, 
    ])

    const innerConfigs = ref({
        scroll: {
            x: 1000,
            y: 200,
        },
        stripe: false,
        bordered: false,
        size: 'large',
        loading: false,
        // rowSelection:{
        //     type: 'checkbox',
        //     showCheckedAll: true,
        //     onlyCurrent: false,
        // },
        selected:[],
        pagination: false,
    })


    const orderStatus = ref({  // 订单状态
        '-1':t('order.finalPayment'), // 尾款单
        '0':t('order.partialPay'), // 部分付款
        '1':t('order.pay'), // 支付
        '2':t('order.refund'), // 全额退款
        '4':t('order.partialRefund'), // 部分退款
        '6':t('order.canceled'), // 取消
        '7':t('order.obligation') // 未付款
    })

    const courierStatus = ref({ // 发货状态
        0:t('order.unship'),
        1:t('order.plan'),
        2:t('order.partialShip'),
        3:t('order.shiped'),
        4:t('order.signedFor'),
        5:t('order.cancel'),
        7:t('order.partialReturn'),
        8:t('order.return'),
        9:t('order.exchange'),
        10:t('order.partialExchange'),
        99:t('order.noNeedToShip'),
    })

    const courierStatusColor = ref({
        0:'magenta', // 未发货
        1:'blue', // 计划发货
        2:'orange', // 部分发货
        3:'lime', // 已发货
        4:'green', // 已签收
        5:'#86909c', // 已关闭
        7:'#ea7ccc', // 部分退货
        8:'#f71ebb', // 部分换货
        9:'#6e74e0', // 退回
        10:'#afb2f5', // 更换
        99:'#333', // 无需发货
    })

    const handle = (type, row)=>{
        switch(type){
            case 'search':
                table.value.configs.pagination.current = 1
                getB2BOrderList()
                break;
            case 'reset':
                queryForm.formField.forEach(item=>{
                    queryForm.formData[item.key] = ''
                })
                queryForm.formData.begin_date = ''
                queryForm.formData.end_date = ''
                table.value.configs.pagination.current = 1
                getB2BOrderList()
                break;
            case 'edit':
                confirmModalVisible.value = true
                order_category.value = ''
                rowData.value = row
                getB2BOrderLine(row)
                break;
            case 'cancel':
                Modal.confirm({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content:t('base.cancelConfirmTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        cancelOrder(row)
                    },
                })
                break;
            case 'close':
                Modal.confirm({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content:t('dealerPreOrder.closeOrderTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        closeOrder(row)
                    },
                })
                break;
        }
    }


    // 展开搜索栏
    const showFormPanel = (val)=>{
        showForm.value = val
    }

    // 列表查询-select
    const handleSelectChange = ( val, opt, key )=>{
        console.log(val,opt,key,'val,opt,key')
        if(key == 'customer_id'){
            if(!val){
                queryForm.formData.customer_name = ''
            }else{
                let item = queryForm.formField.find(i=> i.key == 'customer_id')
                let opt = item.options.find(i=> i.value == val)
                queryForm.formData.customer_name = opt.label
            }
        }else if(key == 'check_status'){
            let item = queryForm.formField.find(i=> i.key == 'courier_status')
            item.disabled = val === 0 || val == 2
            if(val === 0 || val == 2) queryForm.formData.courier_status = ''
        }else{
            queryForm.formData[key] = val
        }
        table.value.configs.pagination.current = 1
        getB2BOrderList()
    }

    // 列表查询-input
    const handleInputClear = (val,item)=>{
        table.value.configs.pagination.current = 1
        getB2BOrderList()
    }
    const handlePressEnter = (val,item)=>{
        table.value.configs.pagination.current = 1
        getB2BOrderList()
    }

    const handlePickerDateChange = (val,item)=>{
        // console.log(val, item, 'handlePickerDateChange')
        table.value.configs.pagination.current = 1
        getB2BOrderList()
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getB2BOrderList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getB2BOrderList()
    }

    // 展开行
    const expandRow = (rowKey,record)=>{
        orderTableRef.value.expandedKeys = orderTableRef.value.expandedKeys.length !== 0? [record.id] : []
        orderTableRef.value.selectedKeys = []
        getB2BOrderLine(record)
    }

    // 金额千分位格式化
    // const toThousands = (val,type)=> { // type: 'de-DE'--德国计数法  'zh-ZH'--中国计数法  'fr-FR'--法国计数法
    //     return new Intl.NumberFormat(type).format(val)
    // }

    // 处理整车零配件确认事件
    const handleConfirmModalOk = () => {
        if(order_category.value === ''){
            Message.error(t('base.pleaseSelectType'))
            return
        }
        rowData.value.order_category = order_category.value
        router.push({name:'OrderOrderList',state:{fromPage:'B2BShopOrder', row: JSON.stringify(rowData.value)}})
    };

    // 获取经销商业务订单列表-头
    const getB2BOrderList = async()=>{
        let form = {}
        queryForm.formField.forEach(i=>{
            if(i.key !== 'order_date'){
                form[i.key] = queryForm.formData[i.key]
            }
        })
        queryForm.formData.begin_date = !queryForm.formData.order_date? '' : dateToTimestamp(`${queryForm.formData.order_date[0]} 00:00:00`)
        queryForm.formData.end_date = !queryForm.formData.order_date? '' : dateToTimestamp(`${queryForm.formData.order_date[1]} 23:59:59`) 

        let param = {
            ...form,
            order_name: queryForm.formData.order_name.trim(),
            begin_date: queryForm.formData.begin_date,
            end_date: queryForm.formData.end_date,
        }

        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true

        let res = await DealerApi.getInstance().getB2BOrderList(param, page_num, page_size)
        if(res.code == 0){
            res.data.records.length > 0 && res.data.records.forEach((item,index)=>{
                item.source_val = item.source
                item.dealer_order_name = item.dealer_order_name == undefined? '-' : item.dealer_order_name
                // item.order_name = item.order_name == undefined? '-' : item.order_name
                item.split_list = item.split_list == undefined? [] : item.split_list
                // item.order_name = item.split_list == undefined || item.split_list.length == 0? '-' : item.split_list[0].order_name
                item.source = item.source == undefined? '-' : orderSource.value[item.source]
                item.dealer_order_status_val = item.dealer_order_status
                item.dealer_order_status = item.dealer_order_status == undefined? '-' : orderStatus.value[`${item.dealer_order_status}`]
                item.quantity = item.quantity == undefined? '-' : item.quantity
                item.check_status_val = item.check_status
                item.check_status = item.check_status == undefined? '-' : item.check_status == 0? t('B2BShopOrder.unconfirm') : item.check_status == 1? t('B2BShopOrder.confirmed') : item.check_status == 3? t('B2BShopOrder.partiallyConfirmed') : t('order.canceled')
                item.courier_status_val = item.courier_status
                item.courier_status = item.courier_status == undefined? '-' : courierStatus.value[item.courier_status]

                item.order_amount = item.order_amount == undefined? '-' : `€ ${Number(item.order_amount).toFixed(2)}`
                item.pay_amount = item.pay_amount == undefined? '-' : `€ ${item.pay_amount}`
                item.order_discount = item.order_discount == undefined? '-' : `€ ${Number(item.order_discount).toFixed(2)}`
                item.cargo_freight = item.cargo_freight == undefined? '-' : `€ ${Number(item.cargo_freight).toFixed(2)}`
                item.order_tax = item.order_tax == undefined? '-' : `€ ${Number(item.order_tax).toFixed(2)}`
                item.tax_rate = item.tax_rate == undefined? '-' : item.tax_rate
                item.create_date = item.create_date == undefined? '-' : item.create_date.split(' ')[0]

                item.order_timestamp = item.order_timestamp == undefined? '-' : timestampToDate(item.order_timestamp * 1000).split(' ')[0]
                item.customer_erp_code = item.customer_erp_code == undefined? '-' : item.customer_erp_code
                item.customer_email = item.customer_email == undefined? '-' : item.customer_email
                item.customer_name = item.customer_name == undefined? '-' : item.customer_name
                item.customer_level_val = item.customer_level
                item.customer_level = item.customer_level == undefined? '-' : item.customer_level == 1? t('dealerPreOrder.bronze') : item.customer_level == 3? t('dealerPreOrder.silver') : item.customer_level == 5? t('dealerPreOrder.gold') : t('dealerPreOrder.platinum')
                item.country = item.country == undefined? '-' : item.country
                item.child = {
                    innerDatas:[],
                    innerColumns:innerColumns.value,
                    innerConfigs:innerConfigs.value,
                }
            })

            table.value.datas = res.data.records
            table.value.configs.pagination.total = res.data.total
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取经销商业务订单列表-行
    const getB2BOrderLine = async(row)=>{
        let param = {
            dealer_order_id: row.id
        }
        let item = table.value.datas.find(i=> i.id == row.id)
        item.child.innerConfigs.loading = true

        let res = await DealerApi.getInstance().getB2BOrderLine(param)
        if(res.code == 0){
            res.data.forEach((item,index)=>{
                item.serial = index + 1
                item.sku = item.sku == undefined? '-' : item.sku
                item.inventory_code = item.inventory_code == undefined? '-' : item.inventory_code
                item.model_year = item.product_map.model_year == undefined? '-' : item.product_map.model_year == 'MY23'? '2023' : '2024'
                item.model_version = item.product_map.model == undefined? '-' : `${item.product_map.model}, ${item.product_map.hf_version}`
                item.ordered_flag_val = item.ordered_flag
                item.ordered_flag = item.ordered_flag == undefined? '-' : item.ordered_flag == 1? t('B2BShopOrder.confirmed') : t('B2BShopOrder.unconfirm')
                item.frame_color = item.product_map.frame_color == 1? '-' : item.product_map.frame_color
                item.frame_shape = item.product_map.frame_shape == undefined? '-' : item.product_map.frame_shape
                item.frame_size = item.product_map.frame_size == undefined? '-' : item.product_map.frame_size
                item.amount = item.amount == undefined? '-' : `€ ${Number(item.amount).toFixed(2)}`
                item.quantity = item.quantity == undefined? '-' : item.quantity
                item.pay_amount = item.pay_amount == undefined? '-' : `€ ${Number(item.pay_amount).toFixed(2)}`
                item.order_tax = item.order_tax == undefined? '-' : `€ ${Number(item.order_tax).toFixed(2)}`
                item.tax_rate = item.tax_rate == undefined? '-' : multiply(item.tax_rate, 100) + '%'
                item.delivery_type_val = item.delivery_type
                item.delivery_type = item.delivery_type == undefined? '-' : item.delivery_type == '1'? t('dealerPreOrder.standard') : item.delivery_type == '2'? t('dealerPreOrder.express') : t('dealerPreOrder.collection')
                item.handle_timestamp_val = item.handle_timestamp_val == undefined? '-' : timestampToDate(item.handle_timestamp_val)
            
                item.user_comment = item.user_comment == undefined? '-' : item.user_comment
                item.user_frame_number = item.user_frame_number == undefined? '-' : item.user_frame_number
            })

            item.child.innerDatas = res.data
            item.child.innerConfigs.loading = false

            if(confirmModalVisible.value){
                line_bike_arr.value = item.child.innerDatas.filter(item => item.product_map.category_code == '627.501' && item.ordered_flag_val == 0)
                line_part_arr.value = item.child.innerDatas.filter(item => item.product_map.category_code == '000.000' && item.ordered_flag_val == 0)
            }
        }else{
            Message.error(res.msg)
        }
    }

    // 取消订单
    const cancelOrder = async (row)=>{
        let param = {
            id: row.id
        }
        let res = await DealerApi.getInstance().cancelOrder(param,row.id)
        if(res.code == 0){
            Message.success(t('base.cancelSuccess'))
            table.value.configs.pagination.current = 1
            getB2BOrderList()
        }else{
            Message.error(res.msg)
        }
    }

    // 关闭业务订单
    const closeOrder = async (row)=>{
        let res = await DealerApi.getInstance().closeOrder(param, row.id)
        if(res.code == 0){
            Message.success(t('dealerPreOrder.closeSuccess'))
            table.value.configs.pagination.current = 1
            getB2BOrderList()
        }else{
            Message.error(res.msg)
        }
    }

    // 获取订单来源类型 和 erp客户编码
    const getOrderSource = async ()=>{
        let res = await OrderApi.getInstance().getOrderSource({enable_flag:1})
        if(res.code == 0){
            let queryFormItem = queryForm.formField.find(i=> i.key == 'source')
            res.data.length > 0 && res.data.forEach(i=>{
                if(i.id){
                    orderSource.value[i.id] = i.id == 1? 'Shopify' : i.customer_name
                }
            })
            res.data.length > 0 && res.data.forEach(i=>{
                queryFormItem.options.push({
                    label: i.id == '1'? 'Shopify' : i.customer_name,
                    value:i.id, // 来源类型
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    // 获取国家下拉配置
    const getCountry = async ()=>{
        let res = await OrderApi.getInstance().getCountry({enable_flag:1})
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'country')
            item.options = []
            res.data.forEach(i=>{
                item.options.push({
                    label:i.country,
                    value:i.country
                })
            })
        }else{
            Message.error(res.msg)
        }
    } 

    // 跳转到订单管理
    const goOrderList = (order_name, check_status)=>{
        if(order_name == '-' || check_status != 1) return
        else router.push({path:'/OrderList/OrderList', query:{order_name:order_name,fromPage:'B2BShopOrder2'}})
    }

    // 处理查询面板伸缩时表格高度
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 50
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 80
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    onMounted(async ()=>{
        await getOrderSource()
        getB2BOrderList()
        getCountry()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })

        sessionStorage.removeItem('toPage')
       
    })


</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: 0;
    }


    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/ .arco-picker-size-medium{
    height: 28px;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 0px 0;
    font-size: 13px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-table-cell-fixed-expand{
    margin-bottom:15px;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

/deep/.childrenTable{
    .arco-table-th{
        background-color: #333 !important;
        color: #fff;
        border-bottom: 1px solid #eee;
        padding: 0;
        font-weight: 300;
        font-size:12px;
    }
    .arco-table-td{
        padding: 0;
        background-color: #ddd !important;
    }

    .arco-icon-filter{
        color: #fff;
    }
}

.amountBlock{
    position: relative;
    font-size:13px;
    color:#666;
    p{
        margin:0px;

        span{
            display: inline-block;
            width: 120px;
        }
    }
}

.amountBlock2{
    position: relative;
    font-size:13px;
    color:#666;
    p{
        margin:0px;

        span{
            display: inline-block;
            width: 70px;
        }
    }
}

.orderName{
    color: #4080ff;
    cursor: pointer;
}

.confirmedName{
    color: #4080ff;
    cursor: pointer;
}

.user_note{
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
}

</style>